import React from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";

import { Grid, Paper, Typography } from "@mui/material";

import SignUpComponent from "../../components/auth/SignUp";

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

const Logo = styled.img`
  width: ${(props) => props.theme.spacing(65)};
`;

function SignUp() {
  return (
    <React.Fragment>
      <Helmet title="Sign Up" />

      <Grid container spacing={18} justifyContent="center">
        <Grid item>
          <Logo src="/static/img/brands/logo.png" alt="" />
        </Grid>
        <Grid item>
          <Wrapper elevation={1}>
            <Grid container spacing={6}>
              <Grid item xs={12}>
                <Typography
                  component="h1"
                  variant="h4"
                  align="center"
                  gutterBottom
                >
                  Sign Up
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <SignUpComponent />
              </Grid>
            </Grid>
          </Wrapper>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default SignUp;
